import { render, staticRenderFns } from "./QuotePremiumInfo.vue?vue&type=template&id=fee8b8a2&scoped=true&"
import script from "./QuotePremiumInfo.vue?vue&type=script&lang=ts&"
export * from "./QuotePremiumInfo.vue?vue&type=script&lang=ts&"
import style0 from "./QuotePremiumInfo.vue?vue&type=style&index=0&id=fee8b8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee8b8a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VForm,VImg,VTooltip})
